import { render, staticRenderFns } from "./ChangeAsesor.vue?vue&type=template&id=4498d866"
import script from "./ChangeAsesor.vue?vue&type=script&lang=js"
export * from "./ChangeAsesor.vue?vue&type=script&lang=js"
import style0 from "./ChangeAsesor.vue?vue&type=style&index=0&id=4498d866&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports